import { j as r } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as j } from "../../../node_modules/clsx/dist/clsx.m.js";
import s from "./ProgressBar.module.scss.js";
import { FieldLabel as f } from "../TextField/components/FieldLabel/FieldLabel.js";
import v from "../TextField/components/FieldHelperText/FieldHelperText.js";
const w = ({
  value: t = 0,
  label: l,
  optionalLabel: d,
  tooltipText: p,
  helperText: i,
  status: m,
  size: o = "medium",
  direction: e = "vertical",
  trackColor: x = "white",
  testId: c,
  content: a
}) => /* @__PURE__ */ r.jsxs(
  "div",
  {
    className: j(
      s.container,
      s[o],
      m && s[m],
      s[e],
      s[x]
    ),
    "data-testid": c,
    children: [
      /* @__PURE__ */ r.jsxs("div", { className: "flex justify-between", children: [
        l && /* @__PURE__ */ r.jsx(
          f,
          {
            label: l,
            optionalLabel: d,
            tooltipText: p,
            size: o === "small" ? "compact" : "regular"
          }
        ),
        e === "vertical" && a && a
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: s.progressBar, children: /* @__PURE__ */ r.jsx(
        "div",
        {
          style: { width: `${t * 100}%` },
          className: s.progress,
          role: "progressbar"
        }
      ) }),
      e === "horizontal" && a && a,
      e === "vertical" && i && /* @__PURE__ */ r.jsx(v, { label: i })
    ]
  }
);
export {
  w as default
};
//# sourceMappingURL=ProgressBar.js.map
